module.exports = __webpack_public_path__ + "media/images/logo_m3com_header-0a503a42471906decfe509feda7e0a3b.png";